// Session log viewer: live tail of GET /api/logs?since= (2s polling while the page is open only),
// with pause, level filter, text filter (machine/character/message) and sticky auto-scroll.
'use strict';
(function () {
  const { t, esc } = App;

  App.i18n.add({
    ko: {
      log_title: '로그',
      log_desc: '모든 머신·세션의 실시간 로그입니다. 2초마다 갱신되며, 이 화면을 떠나면 자동으로 멈춥니다.',
      log_pause: '일시정지', log_resume: '재개', log_paused: '일시정지됨',
      log_level: '레벨', log_filter_ph: '머신·캐릭터·메시지 검색',
      log_lvl_info: '정보', log_lvl_ok: '성공', log_lvl_warn: '경고', log_lvl_err: '오류',
      log_autoscroll: '자동 스크롤', log_jump_latest: '최신으로 ↓',
      log_empty_title: '표시할 로그가 없습니다',
      log_empty_desc: '게임 세션이 시작되면 로그가 여기에 실시간으로 표시됩니다.',
      log_filtered_empty: '필터와 일치하는 로그가 없습니다.',
      log_session: '세션'
    },
    'zh-CN': {
      log_title: '日志',
      log_desc: '所有机器·会话的实时日志。每 2 秒刷新，离开此页面会自动停止。',
      log_pause: '暂停', log_resume: '继续', log_paused: '已暂停',
      log_level: '级别', log_filter_ph: '搜索机器·角色·消息',
      log_lvl_info: '信息', log_lvl_ok: '成功', log_lvl_warn: '警告', log_lvl_err: '错误',
      log_autoscroll: '自动滚动', log_jump_latest: '到最新 ↓',
      log_empty_title: '暂无日志',
      log_empty_desc: '游戏会话开始后，日志会在此实时显示。',
      log_filtered_empty: '没有符合筛选条件的日志。',
      log_session: '会话'
    }
  });

  const LEVELS = ['all', 'info', 'ok', 'warn', 'err'];
  const LEVEL_TONE = { info: 'info', ok: 'ok', warn: 'warn', err: 'bad' };
  const pad = (n) => String(n).padStart(2, '0');
  const clock = (ts) => { const d = new Date(Number(ts)); return pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()); };

  (function injectCss() {
    if (document.getElementById('log-css')) return;
    const style = document.createElement('style');
    style.id = 'log-css';
    style.textContent = `
      .logs-page { height: 100%; }
      .logs-page .log-wrap { position: relative; }
      .log-list { height: calc(100vh - 290px); min-height: 300px; overflow-y: auto; overflow-anchor: none;
        background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 6px; }
      .log-row { display: flex; gap: 10px; align-items: baseline; padding: 3px 8px; border-radius: 6px;
        font-size: 12.5px; line-height: 1.55; }
      .log-row:hover { background: var(--surface-2); }
      .log-row + .log-row { border-top: 1px solid rgba(40,50,64,.4); }
      .log-time { color: var(--faint); flex: none; }
      .log-sid { color: var(--muted); flex: none; min-width: 56px; white-space: nowrap; }
      .log-machine, .log-char { color: var(--muted); flex: none; white-space: nowrap; }
      .log-msg { color: var(--text); flex: 1 1 auto; min-width: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
      .log-row.lv-ok .log-msg { color: var(--ok); }
      .log-row.lv-warn .log-msg { color: var(--warn); }
      .log-row.lv-err .log-msg { color: var(--bad); }
      .log-empty { height: 100%; justify-content: center; }
      .log-jump { position: absolute; right: 16px; bottom: 16px; box-shadow: var(--shadow); }
      .btn.warn-btn { color: var(--warn); border-color: rgba(210,153,34,.45); background: var(--warn-soft); }
      @media (max-width: 640px) {
        .log-list { height: calc(100vh - 320px); }
        .log-machine, .log-char { display: none; }
      }`;
    document.head.appendChild(style);
  })();

  App.page('logs', {
    title: () => t('log_title'),
    nav: { group: 'main', order: 50, icon: '📜' },
    render(root) {
      const state = { all: [], seen: 0, level: 'all', q: '', paused: false, stick: true, timer: null };

      root.innerHTML = `<div class="page logs-page">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('log_title'))}</h1><div class="desc">${esc(t('log_desc'))}</div></div>
          <div class="actions">
            <button class="btn secondary" id="logPause"><span class="dot ok" id="logDot"></span><span id="logPauseLabel">${esc(t('log_pause'))}</span></button>
          </div>
        </div>
        <div class="toolbar">
          <div class="seg" id="logLevels" role="group" aria-label="${esc(t('log_level'))}">${LEVELS.map(lv =>
            `<button type="button" data-lv="${lv}"${lv === 'all' ? ' class="on"' : ''}>${esc(lv === 'all' ? t('all') : t('log_lvl_' + lv))}</button>`).join('')}</div>
          <input type="search" id="logFilter" placeholder="${esc(t('log_filter_ph'))}" aria-label="${esc(t('log_filter_ph'))}">
        </div>
        <div class="log-wrap">
          <div class="log-list mono" id="logList" tabindex="0" aria-label="${esc(t('log_title'))}"></div>
          <button class="btn primary sm log-jump hidden" id="logJump">${esc(t('log_jump_latest'))}</button>
        </div>
      </div>`;

      const list = App.$('#logList', root);
      const jump = App.$('#logJump', root);
      const pauseBtn = App.$('#logPause', root);
      const pauseLabel = App.$('#logPauseLabel', root);
      const pauseDot = App.$('#logDot', root);

      const passes = (e) => {
        if (state.level !== 'all' && (e.level || 'info') !== state.level) return false;
        if (state.q) {
          const hay = ((e.machine || '') + ' ' + (e.char || '') + ' ' + (e.msg || '')).toLowerCase();
          if (!hay.includes(state.q)) return false;
        }
        return true;
      };

      const rowHtml = (e) => {
        const lv = e.level || 'info';
        const tone = LEVEL_TONE[lv] || 'neutral';
        return `<div class="log-row lv-${esc(lv)}">
          <span class="log-time">${esc(clock(e.ts))}</span>
          <span class="dot ${tone}" title="${esc(t('log_lvl_' + lv) || lv)}"></span>
          ${e.sid ? `<span class="log-sid">${esc(t('log_session'))} ${esc(e.sid)}</span>` : '<span class="log-sid"></span>'}
          ${e.machine ? `<span class="log-machine">🖥 ${esc(e.machine)}</span>` : ''}
          ${e.char ? `<span class="log-char">🎮 ${esc(e.char)}</span>` : ''}
          <span class="log-msg">${esc(e.msg)}</span>
        </div>`;
      };

      const atBottom = () => list.scrollHeight - list.scrollTop - list.clientHeight < 48;

      const renderAll = () => {
        const rows = state.all.filter(passes);
        if (!rows.length) {
          list.innerHTML = `<div class="empty-state log-empty">
            <div class="empty-icon">📜</div>
            <p>${esc(state.all.length ? t('log_filtered_empty') : t('log_empty_title'))}</p>
            ${state.all.length ? '' : `<p class="muted small">${esc(t('log_empty_desc'))}</p>`}</div>`;
        } else {
          list.innerHTML = rows.map(rowHtml).join('');
        }
        if (state.stick) { list.scrollTop = list.scrollHeight; jump.classList.add('hidden'); }
      };

      const appendNew = (entries) => {
        const stickBefore = state.stick;
        const frag = [];
        for (const e of entries) if (passes(e)) frag.push(rowHtml(e));
        if (frag.length) {
          const emptyEl = list.querySelector('.log-empty');
          if (emptyEl) list.innerHTML = '';
          list.insertAdjacentHTML('beforeend', frag.join(''));
        }
        if (stickBefore) { list.scrollTop = list.scrollHeight; jump.classList.add('hidden'); }
        else if (frag.length) jump.classList.remove('hidden');
      };

      async function poll() {
        if (state.paused) return;
        const r = await App.api('/api/logs', { query: { since: state.seen || undefined } });
        if (!r.ok || !r.data || !Array.isArray(r.data.entries)) return;
        const fresh = r.data.entries.filter(e => !state.seen || Number(e.ts) > state.seen);
        if (!fresh.length) { if (!state.all.length) renderAll(); return; }
        for (const e of fresh) { state.all.push(e); if (Number(e.ts) > state.seen) state.seen = Number(e.ts); }
        if (state.all.length > 2000) state.all.splice(0, state.all.length - 2000);
        appendNew(fresh);
      }

      // level filter
      App.$$('#logLevels button', root).forEach(b => b.onclick = () => {
        state.level = b.dataset.lv;
        App.$$('#logLevels button', root).forEach(x => x.classList.toggle('on', x === b));
        state.stick = true;
        renderAll();
      });
      // text filter (debounced)
      let deb;
      App.$('#logFilter', root).oninput = (e) => {
        clearTimeout(deb);
        deb = setTimeout(() => { state.q = e.target.value.trim().toLowerCase(); state.stick = true; renderAll(); }, 200);
      };
      // pause toggle
      const setPaused = (on) => {
        state.paused = on;
        pauseLabel.textContent = on ? t('log_resume') : t('log_pause');
        pauseDot.className = 'dot ' + (on ? 'warn' : 'ok');
        pauseBtn.classList.toggle('secondary', !on);
        pauseBtn.classList.toggle('warn-btn', on);
        if (!on) poll();
      };
      pauseBtn.onclick = () => setPaused(!state.paused);
      // scroll tracking → stick / jump button
      list.onscroll = () => {
        state.stick = atBottom();
        jump.classList.toggle('hidden', state.stick);
      };
      jump.onclick = () => { state.stick = true; list.scrollTop = list.scrollHeight; jump.classList.add('hidden'); };

      renderAll();
      poll();
      state.timer = setInterval(poll, 2000);
      return () => clearInterval(state.timer);
    }
  });
})();
